import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Col, Form, Input, Modal, Row, Spin, Table, TableColumnsType } from 'antd';
import Title from 'antd/es/typography/Title';
import { getKrConfirmCompleteMonth, reset, saveComplete, saveCompleteMonth } from 'app/entities/checkIn/checkIn.reducer';
import { displayPercent } from 'app/shared/util/percent';
import { Container } from 'reactstrap';

type IConfirmCompleteProps = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
};

export const ConfirmComplete = ({ isOpen, onClose }: IConfirmCompleteProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filterObjectives = useAppSelector(state => state.filters.objective);
  const updating = useAppSelector(state => state.checkIn.updating);
  const loading = useAppSelector(state => state.checkIn.loading);
  const updateSuccess = useAppSelector(state => state.checkIn.updateSuccess);

  const [data, setData] = useState(null);

  const columnsResult: TableColumnsType<any> = [
    {
      key: 'workStatusName',
      dataIndex: 'workStatusName',
      width: 200,
    },
    {
      title: 'Số KR',
      key: 'monthCount',
      align: 'center',
      dataIndex: 'monthCount',
    },
    {
      title: 'Tỷ lệ',
      key: 'monthProportion',
      align: 'center',
      dataIndex: 'monthProportion',
      render: item => `${displayPercent(item).toFixed(2)}%`,
    },
  ];

  useEffect(() => {
    if (filterObjectives?.planPeriodId) innitData();
  }, [filterObjectives]);

  const innitData = async () => {
    const response = await dispatch(
      getKrConfirmCompleteMonth({ partyId: filterObjectives?.accountableId }),
    );
    if (response && response.payload) {
      const result = response.payload as any;
      if (result.data) {
        setData(result.data);
        form.setFieldsValue({
          adjustmentNote: result.data.adjustmentNote,
          successNote: result.data.successNote,
          failNote: result.data.failNote,
          issue: result.data.issue,
          solution: result.data.solution,
        });
      }
    }
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose(updateSuccess);
    }
  }, [updateSuccess]);

  const handleSubmit = values => {
    (values.partyId = filterObjectives?.accountableId),
      dispatch(saveCompleteMonth(values));
  };

  const handleClose = (reload = false) => {
    onClose(reload);
    dispatch(reset())
  };

  return (
    <Modal
      width={1150}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <Container className="form">
        <Spin spinning={loading} delay={300}>
          <Form size="large" form={form} onFinish={handleSubmit} layout="vertical">
            <Title level={3}>{`Xác nhận hoàn thành check in ${filterObjectives?.accountableName ? `- ${filterObjectives?.accountableName}` : ''}`}</Title>
            <Row>
              <Col>
                <Form.Item label="Kỳ báo cáo">
                  <Input disabled value={data?.reportScheduleName} />
                </Form.Item>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col md={24}>
                <span className="fw-bold h5">KẾT QUẢ THỰC HIỆN MỤC TIÊU</span>
              </Col>
            </Row>
            <Row>
              <Col md={24}>
                <Table
                  pagination={false}
                  bordered
                  dataSource={data?.workLoads}
                  columns={columnsResult}
                  className="w-100"
                  rowClassName={(record, index) => {
                    return index === data?.workLoads.length - 1 ? 'fw-bold' : '';
                  }}
                />
              </Col>
            </Row>
            <Form.Item>
              <Row className="action mt-3" justify="end">
                <Col>
                  <Button type="primary" htmlType="submit" disabled={updating}>
                    Xác nhận hoàn thành
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Hủy
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Container>
    </Modal>
  );
};

export default ConfirmComplete;
